var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-pmode main-area"},[_c('message-area'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-lg-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-lg-8"},[_c('pmode-home')],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-lg-2"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }